var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"like-button",class:{ active: _vm.active },attrs:{"type":"button","disabled":_vm.disabled}},_vm.$listeners),[_c('MaterialIcon',{staticClass:"mr-1",attrs:{"icon":"thumb_up"}}),_c('span',[_vm._t("default",function(){return [_vm._v(" いいね ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }